import React, { FC, useCallback } from 'react';
import { Popup } from 'semantic-ui-react';
import { XDM_ITEM_WITH_AMOUNT_LENGTH } from '../../constants/DataTable';
import { Entity } from '../../interfaces/Entity';
import { getEntityPropertyName } from '../../utils/xdmUtils';

type Props = {
  items: Entity[];
  mappings: { [key: string]: string };
};

export const XdmItemWithAmount: FC<Props> = ({ items, mappings }) => {
  const displayedItems = items.slice(0, XDM_ITEM_WITH_AMOUNT_LENGTH);
  const amountOfHiddenItems = items.length - XDM_ITEM_WITH_AMOUNT_LENGTH;
  const getItemsRender = useCallback(
    (list: Entity[]) =>
      list
        .map(
          (entity: Entity) =>
            entity[getEntityPropertyName(mappings, 'name') ?? '']
        )
        .join(', '),
    [mappings]
  );

  return (
    <span className="xdmContext-field">
      {getItemsRender(displayedItems)}
      {items.length > XDM_ITEM_WITH_AMOUNT_LENGTH ? (
        <Popup
          basic
          pinned
          hoverable
          position="top right"
          className="xdm-tooltip"
          on={'hover'}
          trigger={<span className="xdm-amount">+ {amountOfHiddenItems}</span>}
        >
          <span className="xdm-tooltip">{getItemsRender(items)}</span>
        </Popup>
      ) : null}
    </span>
  );
};
